import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'
import { useQueryClient } from '@tanstack/react-query'

const changePlatformAppStatus = (params: { clientId: string; status: 'COMMUNITY' }) => {
  return PlatformAppsApiClient.changePlatformAppStatus(params, { status: params.status })
}

const useChangePlatformAppStatusMutation = createMutationHook(changePlatformAppStatus, {
  mutationKey: ['changePlatformAppStatus'],
})

export const useChangePlatformAppStatus = () => {
  const queryClient = useQueryClient()
  const { changePlatformAppStatusMutation } = useChangePlatformAppStatusMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['platformAppClients'] })
      queryClient.invalidateQueries({ queryKey: ['platformAppClient'] })
    },
  })

  return {
    changePlatformAppStatus: changePlatformAppStatusMutation.mutate,
    isLoading: changePlatformAppStatusMutation.isLoading,
  }
}
